<template>
  <div id="role-dialog" class="zoom-anim-dialog mfp-hide">
    <div class="small-dialog-header">
      <h3>قوانین و مقررات</h3>
    </div>
    <form>
      <div class="sign-in-wrapper">
        <div
          style="
            padding: 0px 15px 0px 15px;
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 620px;
            font-size: 15px;
            line-height: 2;
          "
        >
          <div>
            <div>
              <div style="color: #2565c0" class="row">
           
                <h3>قوانین و مقررات </h3>
              </div>

              <p v-html="rules" ref="document"></p>

              <h3>استرداد:</h3>
              <p>وجه استرداد بلیت فقط به شماره کارت مسافر مسترد می گردد</p>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>


<script>
import $ from "jquery";
import store from "@/views/profile/store/index";

export default {
  name: "PdkRole",
  store: store,
  components: {},

  data() {
    return {
      popup: {},

      id: "",
      isLoading: false,
    };
  },

  props: {
    rules: String,
  },

  created() {},
  mounted: function () {
    require("magnific-popup");
    $("#close").on("click", function () {
      $.magnificPopup.close();
    });
    this.popup = $(this.$el.querySelector("#role_link")).magnificPopup({
      type: "inline",
      fixedContentPos: true,
      fixedBgPos: true,
      overflowY: "auto",
      closeBtnInside: true,
      preloader: false,
      midClick: true,
      removalDelay: 300,
      mainClass: "my-mfp-zoom-in",
    });
  },

  methods: {
    close() {
      $.magnificPopup.close();
    },
  },

  computed: {},
};
</script>
<style scoped>
.invalid {
  border: 1px solid red !important;
  box-shadow: 0 0 5px red !important;
}
.loading-btn {
  padding-right: 50px !important;
}
.small-dialog-header {
  left: 30px !important;
}
</style>